export enum ProductType {
  Standard = 'standard',
  Datasheet = 'datasheet',
  StatisticsReport = 'statisticsreport',
}
